/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Alarms_Actions_Deselecthistory1Inputs */



/**
* | output |
* | --- |
* | "Deselect {name}" |
*
* @param {Alarms_Actions_Deselecthistory1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_actions_deselecthistory1 = /** @type {((inputs: Alarms_Actions_Deselecthistory1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Actions_Deselecthistory1Inputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Deselect ${i?.name}`)
	return /** @type {LocalizedString} */ (`Désélectionner ${i?.name}`)
});
export { alarms_actions_deselecthistory1 as "alarms_actions_deselectHistory" }